export default "__VITE_ASSET__DLNadqda__"